<template>
  <div class="page-content g9">
    <Accord title="Share">
      <h4>Share your reports with third party</h4>
      <p>
        You may send a link to any third party, the link will automatically expire within 3 months.
      </p>
      <br/>
      <form ref="shareForm" autocomplete="disabled">
        <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>


      </form>
      <div style="width:100%;min-height:45px;">
        <div style="width:50%;float:left;">
          <button @click.prevent="onShareClick" :class="{'loading': shareLoading}">Share simulation</button>
          <div v-if="sharedDone" style="font-weight:bolder;">Simulation shared</div>

        </div>
        <div style="width:50%;text-align:right;float:right;">
          <button v-on:click="onGetSharedUsers">View shared</button>
        </div>

      </div>
    </Accord>
    <div v-if="emailResults.length">
      <Accord title="View sent emails" isClosed="true">

        <div v-for="emailResult in emailResults" class="grid-100w">

          <div class="grid-100w"><b>{{ emailResult.subject }}</b></div>
          <div class="grid-100w">
            {{ emailResult.html }}
          </div>
        </div>

      </Accord>
    </div>
    <div v-if="showSharedUsers">
      <Accord title="Shared simulations">
        <div v-if="sharedUsers.length">
          <table style="width:100%">
            <thead>
            <tr>
              <th style="font-weight:bold;">Email</th>
              <th style="font-weight:bold;">Created</th>
              <th style="font-weight:bold;">Updated</th>
              <th style="font-weight:bold;">Lastlogin</th>
              <th style="font-weight:bold;">Expires</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in sharedUsers">
              <td>{{ user.email }}</td>
              <td>{{ user.created }}</td>
              <td>{{ user.updated }}</td>
              <td>{{ user.lastLoggedIn }}</td>
              <td>{{ user.expires }}</td>
            </tr>
            </tbody>
          </table>
          <br/>
          <p>
            Please note, that you can only renew access by resending a user a new link. You cannot delete a share, it
            will automatically expire.
          </p>
        </div>
        <div v-else>
          <span style="font-weight:bold">There is currently no simulations shared.</span>
        </div>
      </Accord>

    </div>
  </div>
</template>

<script>
import API from "../../../Api"
import Accord from "../Accord.vue"
import FormBuilder from "../FormBuilder.vue"

export default {
  components: {
    Accord,
    FormBuilder
  },
  data: () => ({
    formData: [
      {
        title: "Share settings",
        grid: "grid-50w",
        forms: [{
          type: "text",
          label: "E-mail (comma separated)",
          value: "email"
        }, {
          type: "text",
          label: "Password",
          value: "password"
        }, {
          type: "textarea",
          label: "E-mail text",
          extraClass: "grid-full",
          value: "text"
        }]
      }],
    formValue: {
      email: "",
      password: "",
      text: "Hi,\n\n{study-name} is ready for view.\n\nClick on link below to view simulation.\n\nLogin info:\nE-mail: {email}\nPassword: {password}\n\n{link}"
    },
    emailResults: [],
    shareLoading: false,
    sharedDone: false,
    sharedUsers: [],
    showSharedUsers: false
  }),
  methods: {
    onShareClick() {
      let data = {...this.formValue};
      data.forecastId = this.$store.state.dataView.currentId;

      if (data.email == "" || data.password == "")
        return false;

      this.shareLoading = true;

      API.post("dataview/share", data).then((res) => {

        var emailResults = [];
        if (res.data.emailResults.length > 0) {
          emailResults = res.data.emailResults;
        }
        //this.sharedResults = res.
        // Do some fake loading to show it's shared
        setTimeout(() => {
          this.shareLoading = false;
          this.formValue.email = "";
          this.formValue.password = "";
          this.sharedDone = true;
          this.emailResults = emailResults;
        }, 600);

      }).catch((res) => {
        this.shareLoading = false;
      })
    },
    onGetSharedUsers() {


      var url = "forecast/GetSharedUsers?forecastId=" + this.$store.state.dataView.currentId;


      API.get(url).then((res) => {
        this.sharedUsers = res.data;
        this.showSharedUsers = true;
      });
    }
  }
}
</script>
